import React, { FC, useEffect, useState } from 'react'

import { Button, ButtonProps, YouTubePlayer } from 'shared/components'
import { Link } from 'react-router-dom'
import { sleep } from 'shared/utils'

import img from 'assets/images/zaglushka.png'

import classNames from 'classnames'
import classes from '../VideoSlider.module.scss'
import { useIsMounted, useWindowSize } from 'shared/hooks'

export type VideoSliderItem = {
  isActive?: boolean
  isAnimated?: boolean
  video: string
  title: string
  link?: string
  bgImg?: string
  descr?: string
  btnText?: string
  onBtnClick?: () => void
  noBtn?: boolean
  muted?: boolean
  toggleMute?: () => void
  selectNextSlide?: () => void
  onlyVideo?: boolean
  loop?: boolean
}
export const VideoSliderItem: FC<VideoSliderItem> = ({
  isActive,
  isAnimated,
  title,
  link,
  bgImg,
  video,
  descr,
  btnText = 'Узнать больше',
  onBtnClick,
  noBtn,
  muted = true,
  selectNextSlide = () => null,
  onlyVideo = false,
  loop = false,
}: VideoSliderItem) => {
  const [playing, setPlaying] = useState(false)
  const { isMobile, isTablet } = useWindowSize()
  const mobileDevices = isMobile || isTablet

  const isMounted = useIsMounted()

  useEffect(() => {
    if (!mobileDevices) {
      if (!playing && isActive) {
        sleep(2000).then(() => {
          if (!isMounted()) return
          setPlaying(true)
        })
      } else if (playing && !isActive) {
        if (!isMounted()) return
        sleep(600).then(() => setPlaying(false))
      }
    }
  }, [mobileDevices, playing, isActive, isMounted])

  const renderBtn = () => {
    if (noBtn) {
      return null
    }

    const btnProps: ButtonProps = {
      className: classes.btn,
    }

    if (onBtnClick) {
      btnProps.onClick = () => onBtnClick()
    }

    return <Button {...btnProps}>{btnText}</Button>
  }

  const renderLink = (to: string) => {
    const btn = renderBtn()
    return btn ? <Link to={to}>{btn}</Link> : null
  }

  const catalogItemWrapperClassName = classNames(classes.slider, {
    [classes.slider_hidden]: !isActive,
    [classes.animated]: isAnimated,
  })
  const bgClassName = classNames(classes.bg, {
    [classes.animate_fadeOut]: isActive && playing,
  })
  const videoClassName = classNames(classes.video, {
    [classes.hidden]: !playing,
  })

  return (
    <div className={catalogItemWrapperClassName}>
      <div className={bgClassName}>
        <div>
          <img src={bgImg} alt="" />
        </div>
      </div>
      <YouTubePlayer
        className={videoClassName}
        url={video}
        playing={playing}
        volume={muted ? 0 : 1}
        onEnded={() => selectNextSlide()}
        isActive={isActive}
        loop={loop}
      />
      {!onlyVideo && (
        <>
          <div className={classes.shade} />
          <div className="container">
            <div className={`${classes.info} row`}>
              <div className="col-xs-12 col-sm-8">
                <h1 className={classes.title} key="title_activeSlider">
                  {title}
                </h1>
                <p className={classes.description}>{descr}</p>
              </div>
              <div className="col-xs-12 col-sm-4"></div>
              <div className="col-xs-12">
                {link?.length ? renderLink(link) : renderBtn()}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
